import './UpdateToast.css';

export interface UpdateToastProps {
  onRefresh: () => void;
  onDismiss: () => void;
}

/** Presentational "new version available" toast. */
export function UpdateToast({ onRefresh, onDismiss }: UpdateToastProps) {
  return (
    <div className="update-toast" role="status" aria-live="polite">
      <span className="update-toast__text">New version available</span>
      <div className="update-toast__actions">
        <button
          type="button"
          className="update-toast__btn update-toast__btn--refresh"
          onClick={onRefresh}
        >
          Refresh
        </button>
        <button
          type="button"
          className="update-toast__btn update-toast__btn--dismiss"
          onClick={onDismiss}
        >
          Later
        </button>
      </div>
      {/* An escape hatch, because a service worker can refuse to hand over and
          there is nothing this button can do about it. */}
      <span className="update-toast__hint">
        Still on the old version? Settings &rarr; Force Reload Web App
      </span>
    </div>
  );
}
